import {
  ORGANIZATION_STATUS_LABEL,
  ORGANIZATION_STATUS_TONE,
  VALUE_UNRESOLVED,
} from '../../Consts/backoffice.const';
import {
  OrganizationDetailResponse,
  OrganizationMarketResponse,
  OrganizationRootUserResponse,
  OrganizationSubscriptionResponse,
} from '../../Interfaces/api/backoffice/organization.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class OrganizationDetail {
  id = '';
  name: string | null = null;
  domain: string | null = null;
  avyna_nickname: string | null = null;
  status: string | null = null;
  contact_email: string | null = null;
  billing_currency: string | null = null;
  entra_tenant_id: string | null = null;
  tenant_health_status: string | null = null;
  admin_consent_granted_at: string | null = null;
  installed_at: string | null = null;
  directory_reconciled_at: string | null = null;
  root_missing_flagged_at: string | null = null;
  created_at: string | null = null;
  billing_email: string | null = null;
  billing_email_source: string | null = null;
  billing_email_is_inherited = false;
  market: OrganizationMarketResponse | null = null;
  root_user: OrganizationRootUserResponse | null = null;
  subscription: OrganizationSubscriptionResponse | null = null;
  stripe_customer_id: string | null = null;

  constructor(data: Partial<OrganizationDetailResponse> = {}) {
    Object.assign(this, data);
  }

  get displayName(): string {
    return this.name || this.avyna_nickname || this.domain || this.id;
  }

  get statusLabelKey(): string {
    return this.status ? (ORGANIZATION_STATUS_LABEL[this.status] ?? this.status) : VALUE_UNRESOLVED;
  }

  get statusTone(): StatusTone {
    return this.status ? (ORGANIZATION_STATUS_TONE[this.status] ?? 'neutral') : 'neutral';
  }

  get rootIsMissing(): boolean {
    return this.root_missing_flagged_at !== null;
  }

  get rootUserName(): string {
    return this.root_user?.name || this.root_user?.email || VALUE_UNRESOLVED;
  }

  get currency(): string | null {
    return this.market?.currency ?? this.billing_currency;
  }
}
